import React from 'react';
import './WorkdaysSelector.css';

interface WorkdaysSelectorProps {
  selectedDays: string;
  onChange: (workDays: string) => void;
  disabled?: boolean;
}

export const WorkdaysSelector: React.FC<WorkdaysSelectorProps> = ({
  selectedDays,
  onChange,
  disabled = false
}) => {
  const daysOfWeek = [
    { value: '1', label: 'Mo', fullName: 'Montag' },
    { value: '2', label: 'Di', fullName: 'Dienstag' },
    { value: '3', label: 'Mi', fullName: 'Mittwoch' },
    { value: '4', label: 'Do', fullName: 'Donnerstag' },
    { value: '5', label: 'Fr', fullName: 'Freitag' },
    { value: '6', label: 'Sa', fullName: 'Samstag' },
    { value: '7', label: 'So', fullName: 'Sonntag' }
  ];

  const selectedDaysArray = selectedDays ? selectedDays.split(',').map(d => d.trim()) : [];

  const handleDayToggle = (dayValue: string) => {
    if (disabled) return;

    let newSelectedDays: string[];
    
    if (selectedDaysArray.includes(dayValue)) {
      newSelectedDays = selectedDaysArray.filter(d => d !== dayValue);
    } else {
      newSelectedDays = [...selectedDaysArray, dayValue].sort((a, b) => parseInt(a) - parseInt(b));
    }
    
    onChange(newSelectedDays.join(','));
  };

  const selectPreset = (preset: string[]) => {
    if (disabled) return;
    onChange(preset.join(','));
  };

  return (
    <div className="workdays-selector">
      <div className="days-grid">
        {daysOfWeek.map(day => (
          <button
            key={day.value}
            type="button"
            className={`day-button ${selectedDaysArray.includes(day.value) ? 'selected' : ''}`}
            onClick={() => handleDayToggle(day.value)}
            disabled={disabled}
            title={day.fullName}
          >
            {day.label}
          </button>
        ))}
      </div>
      
      <div className="preset-buttons">
        <button
          type="button"
          className="preset-btn"
          onClick={() => selectPreset(['1', '2', '3', '4', '5'])}
          disabled={disabled}
        >
          Mo-Fr
        </button>
        <button
          type="button"
          className="preset-btn"
          onClick={() => selectPreset(['1', '2', '3', '4', '5', '6'])}
          disabled={disabled}
        >
          Mo-Sa
        </button>
        <button
          type="button"
          className="preset-btn"
          onClick={() => selectPreset(['1', '2', '3', '4', '5', '6', '7'])}
          disabled={disabled}
        >
          Alle Tage
        </button>
      </div>

      <div className="selected-display">
        <small>
          Ausgewählt: {selectedDaysArray.length > 0 
            ? selectedDaysArray.map(d => daysOfWeek.find(day => day.value === d)?.label).join(', ')
            : 'Keine Arbeitstage'
          }
        </small>
      </div>
    </div>
  );
};
